import { Box, styled } from "@mui/system";

const PaperBox = styled(Box)({
  backgroundColor: "white",
  boxShadow: "0px 30px 36px #557DA526",
  borderRadius: "20px",
});

export default PaperBox;
